import { t } from '@lingui/core/macro';
import { LoaderOverlay } from '@pocketlaw/tetris';
import { Content } from '../styled';
export function LoadingState() {
    return (<Content>
      <LoaderOverlay label={t({
            comment: 'Select prompt dialog - Loading message',
            message: 'Loading prompts...',
        })}/>
    </Content>);
}
